<form [formGroup]="formGroup">
  <ng-template #inputField>
    @if (fieldConfig.type === 'date') {
      <p-calendar
        [inputId]="inputId"
        [disabled]="disabled"
        [formControlName]="fieldConfig.name"
        appendTo="body"
        dateFormat="dd.mm.yy"
        [ariaLabel]="fieldConfig.label"
        [placeholder]="fieldConfig.placeholder ?? ''"
        [minDate]="dateMode === 'future' ? minDate : null"
        [maxDate]="dateMode === 'past' ? maxDate : null">
      </p-calendar>
    } @else if (fieldConfig.type === 'password') {
      <p-password
        [inputId]="inputId"
        [disabled]="disabled"
        [formControlName]="fieldConfig.name"
        [feedback]="showPasswordRules"
        [toggleMask]="true"
        autocomplete="on"
        [ariaLabel]="fieldConfig.label">
        @if (showPasswordRules) {
          <ng-template #footer>
            <p-divider></p-divider>
            <ul>
              <li>Au moins une lettre minuscule</li>
              <li>Au moins une lettre majuscule</li>
              <li>Au moins un caractère spécial</li>
              <li>Au moins un chiffre</li>
              <li>Minimum 8 caractères</li>
            </ul>
          </ng-template>
        }
      </p-password>
    } @else {
      <input
        pInputText
        [id]="inputId"
        [formControlName]="fieldConfig.name"
        [type]="inputType"
        [min]="fieldConfig.min"
        [disabled]="disabled"
        [placeholder]="fieldConfig.placeholder ?? ''"
        autocomplete="on" />
    }
  </ng-template>

  @if (useIftaLabel) {
    <p-iftalabel>
      <ng-container *ngTemplateOutlet="inputField"></ng-container>
      <label [for]="inputId">{{ fieldConfig.label }}</label>
    </p-iftalabel>
  } @else {
    <p-floatlabel [variant]="variant">
      <ng-container *ngTemplateOutlet="inputField"></ng-container>
      <label [for]="inputId">{{ fieldConfig.label }}</label>
    </p-floatlabel>
  }
</form>
